var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('empty-state',{staticClass:"absolute-center",attrs:{"icon":_vm.$root.icons.layout.alert}},[_vm._v(" Ops! Ocorreu um erro ")])}
var staticRenderFns = []

export { render, staticRenderFns }